// Address is purely semantic HTML — no JS needed.
